/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Stripe recurring interval unit — the cadence a subscription bills on.
 */
export type BillingInterval =
  (typeof BillingInterval)[keyof typeof BillingInterval];

export const BillingInterval = {
  day: "day",
  week: "week",
  month: "month",
  year: "year",
} as const;
